module.exports = __webpack_public_path__ + "static/media/hidden.af5e24d8.svg";